<template>
  <div style="position: relative;height:90px;width:100%;">
    <canvas id="myChart3"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "paymentplan-chart",

  props: { paymentPlan: null },
  data() {
    return {
      options: {
        plugins: {
          tooltip: { enabled: false },
        },
        hover: { mode: null },
        cutout: 75,

        responsive: true,
        maintainAspectRatio: true,
      },
    };
  },
  watch: {
    paymentPlan: {
      handler(val) {
        this.chart.data = this.fillData();
        this.chart.update();
      },
      deep: true,
    },
  },
  mounted() {
    var self = this;
    const ctx = document.getElementById("myChart3").getContext("2d");
    this.chart = new Chart(ctx, {
      type: "doughnut",
      data: this.fillData(),
      options: this.options,
      plugins: [
        {
          id: "text",
          beforeDraw: function(chart, a, b) {
            if (self.paymentPlan) {
              var width = chart.width,
                height = chart.height,
                ctx = chart.ctx;

              ctx.restore();
              var fontSize = (height / 240).toFixed(2);
              ctx.font = fontSize + "em 'SF Pro', sans-serif";

              if (self.paymentPlan.status == "COMPLETE")
                ctx.fillStyle = "#59a5d8";
              else if (self.paymentPlan.status == "INACTIVE")
                ctx.fillStyle = "#adb5bd";
              else if (self.paymentPlan.status == "ACTIVE")
                ctx.fillStyle = "#2dce89";

              ctx.textBaseline = "middle";

              var text =
                self.paymentPlan.currentCycle +
                " of " +
                self.paymentPlan.cycleCount;

              let textX = Math.round((width - ctx.measureText(text).width) / 2);
              let textY = height / 2 + 8;

              ctx.fillText(text, textX, textY);
              ctx.save();
            }
          },
        },
      ],
    });
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    fillData() {
      let chartData = [];
      let chartColor = [];

      this.paymentPlan.paymentPlanDetails.forEach((e) => {
        if (!e.isDownPayment) {
          chartData.push(1);

          if (e.processedToLedger && this.paymentPlan.status == "COMPLETE")
            chartColor.push("#59a5d8");
          else if (e.processedToLedger && this.paymentPlan.status == "INACTIVE")
            chartColor.push("#adb5bd");
          else if (e.processedToLedger && this.paymentPlan.status == "ACTIVE")
            chartColor.push("#2dce89");
          else chartColor.push("#f6f9fc");
        }
      });
      return {
        datasets: [
          {
            circumference: 360,
            backgroundColor: chartColor,
            data: chartData,
          },
        ],
      };
    },
  },
};
</script>

<style></style>
